import { features } from '@utils/use-features';

const siteTitle = 'Jamie De Rycke - Personal website, portfolio and blog of a web monkey';
const pageTransition = 'fade';

export default [
  {
    component: () => import('./views/HomeView.vue'),
    meta: {
      label: 'Home',
      step: true,
      title: siteTitle,
      transition: pageTransition,
    },
    name: 'home',
    path: '/',
  },
  {
    component: () => import('./views/AboutView.vue'),
    meta: {
      label: 'About',
      step: true,
      title: `About me | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'about',
    path: '/about/',
    strict: true,
  },
  {
    component: () => import('./views/WorkView.vue'),
    meta: {
      label: 'Work',
      step: !!features.showWork,
      title: `My work | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'work',
    path: '/work/',
    strict: true,
  },
  {
    component: () => import('./views/WorkItemView.vue'),
    meta: {
      label: 'Work item',
      step: false,
      title: `My work | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'workItem',
    path: '/work/item/:id/',
    strict: true,
  },
  {
    component: () => import('./views/BlogView.vue'),
    meta: {
      label: 'Blog',
      step: !!features.showBlog,
      title: `Blog | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'blog',
    path: '/blog/',
    strict: true,
  },
  {
    component: () => import('./views/BlogPostView.vue'),
    meta: {
      label: 'Blog post',
      step: false,
      title: `Blog | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'blogPost',
    path: '/blog/post/:id/',
    strict: true,
  },
  {
    component: () => import('./views/CookiePolicy.vue'),
    meta: {
      label: 'Cookie policy',
      step: false,
      title: `Cookie policy | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'cookiePolicy',
    path: '/cookie-policy/',
    strict: true,
  },
  {
    component: () => import('./views/_500.vue'),
    meta: {
      step: false,
      title: `(500) Technical fault | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'techFault',
    path: '/500/',
    strict: true,
  },
  {
    component: () => import('./views/_404.vue'),
    meta: {
      step: false,
      title: `(404) Page not found | ${siteTitle}`,
      transition: pageTransition,
    },
    name: 'notFound',
    path: '/404/',
    props: true,
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'notFound' },
  },
];
